export interface IResourcesCapability {
  resourceCategoriesUrl: string;
  resourcesUrl: string;
}

export class ResourcesConfiguration {
  private _capability: IResourcesCapability;

  constructor() {}

  configureCapability(capability: IResourcesCapability) {
    this._capability = capability;
  }

  get capability() {
    return this._capability;
  }

  $get() {
    return this;
  }
}

angular.module('capability-ng-resources').provider('ngResourcesConfiguration', ResourcesConfiguration);



// WEBPACK FOOTER //
// ./app/lib/resources/config/resources_configuration.ts